import { PortfolioStep } from './portfolio.types';

export const PROCESS_STEPS: PortfolioStep[] = [
  { num: '01', title: '상담 & 컨셉 미팅', desc: '브랜드 톤, 컬러 팔레트, 박스 형태, 예산 범위를 함께 정리합니다.' },
  { num: '02', title: '2D / 3D 시안 구축', desc: '패키지 형태를 3D 렌더링으로 미리 확인하실 수 있도록 제공합니다.' },
  { num: '03', title: '실물 샘플 제작', desc: '슬리브·트레이·리본 등 핵심 디테일의 실제 샘플을 제출합니다.' },
  { num: '04', title: '본 생산 & 납품', desc: '자체 공장 운영으로 정직한 가격, 빠른 납기, 안정적인 품질을 보장합니다.' },
];

export const DETAIL_FAQ = [
  { question: '시안은 몇 회까지 수정 가능한가요?', answer: '기본 시안 1회 무료, 추가 시안 작업 시 견적에 함께 안내드립니다.' },
  { question: '환경 인증 마크도 인쇄 가능한가요?', answer: 'FSC · 환경부 인증 마크 모두 위치·사이즈 조절해 인쇄 가능합니다.' },
  { question: '소량 제작도 가능한가요?', answer: '친환경 박스는 300개부터, 일반 박스는 500개부터 주문 가능합니다.' },
];

export const CONSULTANT = {
  initial: 'K',
  name: '김윤서 컨설턴트',
  email: 'box@gworks.kr',
  phone: '031-925-6547',
};
